export default [
    {
        name: 'stripe.confirmPayment',
        path: '/confirmPayment/',
        meta: { auth: undefined },
        component: () => import('./ConfirmPayment.vue')
    }
]
